import * as validator from "./validators/validator";

export const ACQUSITIONS_PENDING = 0;
export const ACQUSITIONS_PENDING_BUT_HAS_INVOICE = 1;
export const ACQUSITIONS_DONE = 2;

export const ACCOUNTING_PENDING = 0;
export const ACCOUNTING_DONE = 1;

export const RECEPTION_PENDING = 0;
export const RECEPTION_DONE = 1;

export function isAcquisitionDone(state) {
    return ACQUSITIONS_DONE === state;
}

export function isAccountingDone(state) {
    return ACCOUNTING_DONE === state;
}

export function isReceptionDone(state) {
    return RECEPTION_DONE === state;
}

export function getAcquisitionState(d) {
    if (
        validator.isEmpty(d.budgetaryApprovedCredits)
        || validator.isEmpty(d.budgetaryCommitmentValueVat)
        || validator.isEmpty(d.budgetaryCommitmentNumberDate)
        || validator.isEmpty(d.acquisitionProcedure)
        || validator.isEmpty(d.bidderCompanyName)
        || validator.isEmpty(d.bidEvaluationCriterion)
        || validator.isEmpty(d.bidValueNoVat)
        || validator.isEmpty(d.obtainedPoints)
        || validator.isEmpty(d.winningBidPriceVat)
        || validator.isEmpty(d.numberLegalCommitment)
        || validator.isEmpty(d.billNrDate)
    ) {
        return ACQUSITIONS_PENDING
    }

    return ACQUSITIONS_DONE;
}

export function getAccountingState(details) {
    return (!validator.isEmpty(details.paymentOpNrDate) && !validator.isEmpty(details.paymentValue)) ? ACCOUNTING_DONE : ACCOUNTING_PENDING;

}

export function getReceptionState(details) {
    return (!validator.isEmpty(details.receptionNrNote) && !validator.isEmpty(details.receptionDate)) ? RECEPTION_DONE : RECEPTION_PENDING;
}